
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "0fa32127-2b7e-4af1-af3a-50d715ed6934"
  },
  "ui": {
    "primary": "green",
    "gray": "cool",
    "colors": [
      "green",
      "red",
      "primary"
    ],
    "strategy": "merge"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/tmp/build/d411e185/code/app.config.js"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
